import axios from 'axios';
import { NextResponse } from 'next/server';

import config from '@/../config';

export async function getToken() {
  if (typeof window === 'undefined') {
    // Running on server: localStorage is not available
    throw new Error('Cannot access localStorage on the server');
  }

  const token = localStorage.getItem('id_token');
  return token;
}

export async function getWithoutToken(url: string) {
  try {
    const response = await axios.get(`${config.middleware}/${url}`, {
      headers: {
        'Content-Type': 'application/json',
      },
    });
    return response.data;
  } catch (error) {
    console.error('Proxy fetch error:', error);
    return undefined;
  }
}

export async function get(url: string) {
  try {
    const token = await getToken();

    if (!token) return;
    const response = await axios.get(`${config.middleware}/${url}`, {
      headers: {
        authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });
    return response.data;
  } catch (error) {
    console.error('Proxy fetch error:', error);
    return NextResponse.json({ error: 'Failed to fetch data' }, { status: 500 });
  }
}

export async function post(url: string, payload?: object) {
  try {
    const token = await getToken();
    if (!token) return;
    const fullUrl = `${config.middleware}/${url}`;

    // Conditionally include payload (avoid sending "undefined")
    const response = payload
      ? await axios.post(fullUrl, payload, {
          headers: {
            authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        })
      : await axios.post(
          fullUrl,
          {},
          {
            headers: {
              authorization: `Bearer ${token}`,
              'Content-Type': 'application/json',
            },
          },
        );
    return response;
  } catch (error) {
    console.error('Proxy POST error:', error);
    return NextResponse.json({ error: 'Failed to post data' }, { status: 500 });
  }
}

export async function postWithoutToken(url: string, payload?: object) {
  try {
    const fullUrl = `${config.middleware}/${url}`;
    const response = payload
      ? await axios.post(fullUrl, payload, {
          headers: {
            'Content-Type': 'application/json',
          },
        })
      : await axios.post(
          fullUrl,
          {},
          {
            headers: {
              'Content-Type': 'application/json',
            },
          },
        );
    return response;
  } catch (error) {
    console.error('Proxy POST error:', error);
    return NextResponse.json({ error: 'Failed to post data' }, { status: 500 });
  }
}

export async function deleteRequest(url: string, payload?: object) {
  try {
    const token = await getToken();
    if (!token) return;
    const fullUrl = `${config.middleware}/${url}`;

    // Conditionally include payload (avoid sending "undefined")
    const response = payload
      ? await axios.delete(fullUrl, {
          headers: {
            authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
          data: payload,
        })
      : await axios.delete(fullUrl, {
          headers: {
            authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        });

    return response;
  } catch (error) {
    console.error('Proxy POST error:', error);
    return NextResponse.json({ error: 'Failed to post data' }, { status: 500 });
  }
}
